import * as React from 'react';

import { styled } from '@mui/material';
import Box, { BoxProps } from '@mui/material/Box';

import { TikTokIcon } from '../Icons';

export type TikTokTagProps = {
  tiktokHandle?: string | null;
  textColor?: string;
  customFontSize?: string;
  showAtSign?: boolean;
  showIcon?: boolean;
} & BoxProps;

export const TikTokLink = styled(Box)<{
  target?: string;
  href?: string;
  textColor?: string;
  customFontSize?: string;
}>(({ textColor, customFontSize }) => ({
  color: textColor || '#0C66E4',
  fontSize: customFontSize || '14px',
  textDecoration: 'none',
  display: 'inline-flex',
  alignItems: 'center',
  gap: '8px',
  ':hover': {
    textDecoration: 'underline',
  },
}));

const TikTokTag: React.FC<TikTokTagProps> = ({
  tiktokHandle,
  showAtSign = true,
  showIcon = false,
  ...restProps
}) => {
  return (
    tiktokHandle && (
      <TikTokLink
        component='a'
        target='_blank'
        href={`https://tiktok.com/@${tiktokHandle}`}
        {...restProps}
      >
        {showIcon && <TikTokIcon sx={{ fontSize: 'inherit' }} />}
        {showAtSign ? `@${tiktokHandle}` : tiktokHandle}
      </TikTokLink>
    )
  );
};

export default TikTokTag;

